import type { ComponentType } from 'react';
import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';

interface PropsWithMobile {
  isMobile?: boolean;
}

export default function withMobile<P extends PropsWithMobile>(
  WrappedComponent: ComponentType<P>,
) {
  const mapPropsToState = (state) => ({
    isMobile: getIsMobile(state),
  });
  return connect(mapPropsToState)(WrappedComponent as any) as ComponentType<
    Omit<P, 'isMobile'>
  >;
}
